import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import useNotification from "../hooks/notification";
import useMutation from "../hooks/useMutation";
import { UPDATE_USER_ACCOUNT_MUTATION } from "../constants/graphql";

const ToggleUserActiveModal = ({ open, onClose, entity, isDisabling, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const { notifySuccess, notifyError } = useNotification();
  const [updateAction] = useMutation(UPDATE_USER_ACCOUNT_MUTATION);
  const action = isDisabling ? "disable" : "enable";

  const handleConfirm = () => {
    setLoading(true);

    return updateAction({
      variables: { id: entity.id, active: !isDisabling },
      onSuccess: () => {
        setLoading(false);
        notifySuccess(
          isDisabling
            ? "User has been successfully disabled!"
            : "User has been successfully enabled!"
        );
        onClose();
        if (onSuccess) onSuccess();
      },
      onFailure: (errors) => {
        setLoading(false);
        notifyError(errors);
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Typography align="center" fontSize={20} fontWeight={500} color="text.primary">
          {isDisabling ? "Disable User" : "Enable User"}
        </Typography>
        <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to {action} user <strong>{entity.name || entity.email}</strong>?{" "}
          {isDisabling
            ? "They will no longer be able to access the system."
            : "They will regain access to the system."}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={handleConfirm} disabled={loading}>
          {isDisabling ? "Disable" : "Enable"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ToggleUserActiveModal;
